/* eslint-env node */
/**
 * Drupal ships jQuery via the `core/jquery` library (declared as a dependency of
 * `sd/global` in sd.libraries.yml), so it is always on `window` before this
 * bundle runs. Aliasing the `jquery` bare specifier to this shim keeps jQuery
 * out of the bundle while satisfying both `import $ from 'jquery'` and the
 * `require('jquery')` calls in older UMD plugins (jquery-once, slick-carousel).
 */
module.exports = window.jQuery;
